import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Navigation from "./Navigation";
import Footer from "./Footer";
import LeftColomn from "./LeftColomn";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import logo from "../images/mocologo.jpeg";
import Wrapper from "../Helpers/Wrapper";
import MenuContext from "../store/menu-context";


const Layout = (props) => {
  const menuItems = useContext(MenuContext);

  return (
    <Wrapper>
      <Container className="p-1">
      <Navigation/>
      </Container>
      <Container className="p-5">
        <Row>
          <Col xs={4}>
            <Link to="/">
            <Image src={logo} fluid className="p-2"></Image>
            </Link>
          </Col>
          <Col xs={8}>
            <Row className="align-middle"><p></p><p></p><h2>Montgomery County Music Teachers Association</h2></Row>
          </Col>
        </Row>
        <Row><Col lg={12} className="gy-3">{props.children}</Col></Row>
      </Container>
      <Footer />
    </Wrapper>
  );
};

export default Layout;
